"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTriggerDetectTaxes = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var backend_1 = require("utils/backend");
var hooks_1 = require("utils/hooks");
var populated_1 = require("utils/selectors/populated");
var single_1 = require("utils/selectors/single");
var useTriggerDetectTaxes = function () {
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var rechargerOrgs = (0, react_redux_1.useSelector)(populated_1.selectPopRechargedOrganizations);
    var _a = __read((0, hooks_1.useSubmitter)('recharger_companies', rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.id), 1), rechargerCompanySubmitter = _a[0];
    react_1.default.useEffect(function () {
        var lastTaxDetection = rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.lastTaxDetection;
        if (rechargerCompany && (rechargerOrgs === null || rechargerOrgs === void 0 ? void 0 : rechargerOrgs.length) && !rechargerCompany.isDetectingTaxes
            && (!lastTaxDetection || rechargerOrgs.some(function (rO) { return rO.connectedOn && rO.connectedOn.toMillis() > lastTaxDetection.toMillis(); }))) {
            rechargerCompanySubmitter({ isDetectingTaxes: true })
                .then(function () { return (0, backend_1.callBackendFn)('dataextract-detecttaxes', { companyId: rechargerCompany.id }); });
        }
    }, [!rechargerCompany, (0, react_redux_firebase_1.isLoaded)(rechargerOrgs)]);
};
exports.useTriggerDetectTaxes = useTriggerDetectTaxes;
